(() => {
  if (window.topicsUIReady) return;
  window.topicsUIReady = true;
  document.addEventListener('click', (event) => {
    const bag = event.target.closest('[data-tf-cart]');
    const drawer = document.getElementById('cart-drawer');
    if (bag && drawer && typeof drawer.open === 'function') {
      event.preventDefault();
      drawer.open();
    }
    const opener = event.target.closest('[data-tf-open]');
    if (opener) {
      if (opener.dataset.tfOpen === 'tf-newsletter-popup') {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'UHtugB']);
      } else {
        const dialog = document.getElementById(opener.dataset.tfOpen);
        if (dialog) { dialog.showModal(); dialog.dataset.opener = opener.dataset.tfOpen; }
      }
    }
    const closer = event.target.closest('[data-tf-close]');
    if (closer) closer.closest('dialog').close();
    if (event.target.matches('dialog.tf-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
    if (event.target.closest('.tf-mobile-nav a')) event.target.closest('.tf-mobile-nav').removeAttribute('open');
  });
  document.addEventListener('shopify:cart:lines-update', event => {
    event.promise?.then(({cart, detail}) => {
      const count = cart?.totalQuantity ?? detail?.itemCount;
      if (typeof count !== 'number') return;
      document.querySelectorAll('.tf-bag-count').forEach(el => { el.textContent = String(count); });
      document.querySelectorAll('[data-tf-cart]').forEach(el => el.setAttribute('aria-label', `Winkeltas, ${count} artikelen`));
    }).catch(() => {});
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.tf-mobile-nav[open]').forEach(menu => menu.removeAttribute('open'));
  });
})();
